import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { ProductGroupResource } from "@exonn/js-sdk";

export const module: ModuleOptions<ProductGroupResource> = {
  resource: ResourceEnum.ProductGroup,
  bigIcon: <i className="icon-20-groups_gds" />,
  smallIcon: <i className="icon-15-groups_gds" />,
};
